// extracted by mini-css-extract-plugin
module.exports = {"copies":"copies___2qu0L","copy":"copy___1Q-Ey"};